import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { Observable } from 'rxjs';

import { Keys, PersistenceService } from './../../core/services/persistence.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor(
    private router: Router,
    private persistenceService: PersistenceService
    ) { }

  canActivate(): boolean {
    return this.evaluateAuth();
  }

  canLoad(): boolean {
    return  this.evaluateAuth();
  }

  private evaluateAuth(){
    const isAuthenticate =  JSON.parse(this.persistenceService.getValue(Keys.isAuthenticate));
    if (isAuthenticate) { return true; }
    this.router.navigate(['/login']);
    return false;
  }
}
